import React from 'react'

class PollInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      idToadd: 0,
      pollInfo: [
        {
          pollOptionID: 0,
          votes: 0,
        },
      ],
      dragID: '',
    }
  }

  componentDidMount() {
    if (this.props.pollDetails && this.props.pollDetails.pollInfo) {
      const pollInfo = this.props.pollDetails.pollInfo
      pollInfo.sort((a, b) => parseFloat(a.ordering) - parseFloat(b.ordering))
      pollInfo.map((item) => {
        delete item.__typename
      })
      this.setState({
        pollInfo: this.props.pollDetails.pollInfo,
        idToadd: this.props.pollDetails?.pollInfo?.length,
      })
      this.props.updatepollInfo(this.props.pollDetails.pollInfo)
    }
  }

  updateOptionsInPoll = () => {
    this.props.updatepollInfo(this.state.pollInfo)
  }
  addOption = () => {
    const pollInfo = this.state.pollInfo
    pollInfo.push({
      pollOptionID: this.state.idToadd + 1,
      votes: 0,
    })
    this.setState({ pollInfo: pollInfo, idToadd: this.state.idToadd + 1 })
    if (this.state.pollInfo.length > 1) {
      this.setState({ displaySort: true })
    }
  }
  handleOption = (e, index) => {
    const pollInfo = this.state.pollInfo
    pollInfo[index][`choice_${this.props.contentSelectedLangVal}`] = e.target.value
    this.setState({ pollInfo: pollInfo }, () => {
      this.updateOptionsInPoll()
    })
  }
  handleRemoveOption = (index) => {
    const pollInfo = this.state.pollInfo
    pollInfo.splice(index, 1)
    pollInfo.map((item, index) => {
      item.pollOptionID = index
    })
    this.setState(
      {
        pollInfo: pollInfo,
        idToadd: this.state.idToadd - 1,
      },
      () => {
        this.updateOptionsInPoll()
      }
    )
  }

  handleDrag = (e) => {
    this.setState({ dragID: e.target.id })
  }
  handleDrop = (e) => {
    const { pollInfo } = this.state
    const dragIndex = this.state.dragID
    const dropIndex = e.currentTarget.id
    const dragItem = pollInfo[dragIndex]
    const dropItem = pollInfo[dropIndex]
    pollInfo[dragIndex] = dropItem
    pollInfo[dropIndex] = dragItem
    this.setState({ pollInfo: pollInfo })
    this.updateOptionsInPoll()
  }
  renderItem = (item, index) => {
    return (
      <div style={{ display: 'inline-block' }}>
        <input
          type='text'
          onChange={(e) => {
            this.handleOption(e, index)
          }}
          value={item[`choice_${this.props.contentSelectedLangVal}`]}
          placeholder='Please Enter Option '
        ></input>
        <text onClick={() => this.handleRemoveOption(index)}>X</text>{' '}
      </div>
    )
  }
  render() {
    const { pollInfo } = this.state
    return (
      <div className='flex-container'>
        <div>
          <text for='text'>Poll Options :</text>
        </div>
        {pollInfo.map((value, id) => {
          return (
            <div
              draggable={true}
              id={id}
              onDragOver={(ev) => ev.preventDefault()}
              onDragStart={this.handleDrag}
              onDrop={this.handleDrop}
            >
              {this.renderItem(value, id)}
            </div>
          )
        })}

        <button onClick={() => this.addOption()}>{'Add Option'}</button>
      </div>
    )
  }
}

export default PollInfo
